import { MatchStatus } from '@okletsplay/core';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => {
  const {
    palette: { success, secondary },
    spacing,
  } = theme;

  const OPEN_MATCH_BOX_SHADOW = `0 ${spacing(-0.5)} 0 ${spacing(-0.125)} ${success.light} inset`;
  const PAST_MATCH_BOX_SHADOW = 'none';

  return {
    root: {
      backgroundColor: theme.palette.background.paper,
      height: theme.spacing(13.5),
      border: '1px solid transparent',
      borderRadius: theme.spacing(1),
      position: 'relative',
      padding: theme.spacing(1.5),

      '&:hover': {
        borderColor: theme.palette.primary.light,
        cursor: 'pointer',
      },

      '& .text-overflow': {
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
      },
    },
    userName: {
      marginLeft: theme.spacing(1.5),
      maxWidth: theme.spacing(15),
      alignItems: 'flex-start',
      fontFamily: 'Bebas Neue',
      fontSize: theme.spacing(2.25),
      letterSpacing: '0.9px',
    },
    gameIcon: {
      objectFit: 'contain',
      width: theme.spacing(4),
      height: theme.spacing(4),
    },
    matchType: {
      textTransform: 'uppercase',
    },
    statusBlock: {
      display: 'flex',
      justifyContent: 'space-between',

      '& .MuiTypography-root': {
        fontSize: theme.spacing(1.5),
      },
    },
    openMatchLabel: {
      color: success.light,
    },
    finishedMatchLabel: {
      color: secondary.light,
    },

    [MatchStatus.Created]: { boxShadow: OPEN_MATCH_BOX_SHADOW },
    [MatchStatus.Pending]: { boxShadow: OPEN_MATCH_BOX_SHADOW },
    [MatchStatus.Live]: { boxShadow: OPEN_MATCH_BOX_SHADOW },
    [MatchStatus.Lobby]: { boxShadow: OPEN_MATCH_BOX_SHADOW },

    [MatchStatus.Expired]: { boxShadow: PAST_MATCH_BOX_SHADOW },
    [MatchStatus.Declined]: { boxShadow: PAST_MATCH_BOX_SHADOW },
    [MatchStatus.Canceled]: { boxShadow: PAST_MATCH_BOX_SHADOW },
    [MatchStatus.Finished]: { boxShadow: PAST_MATCH_BOX_SHADOW },
    [MatchStatus.Aborted]: { boxShadow: PAST_MATCH_BOX_SHADOW },
  };
});
